import qs from 'qs'
import type { ViewByOptionsQueryParams, ViewByOptionsQueryParamsOptions } from '@/api/kubik/credit'
import { ViewByOptionsQueryParamsProcessingSpeed } from '@/api/kubik/credit'
import {
  ALL_REGIONS_CODE,
  formKnownValues,
} from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsFilter/constants'
// todo: "кража" типа с другой страницы
import { isNonNullable } from '@/typeguards/common'
import { messages } from './messages'
import type { ILoanProductsFilterForm, ILoanProductsFilterQueryParams } from './types'

export const sumFormatter = (showCurrency = false) =>
  new Intl.NumberFormat('ru-RU', {
    ...(showCurrency && { style: 'currency', currency: 'RUB' }),
    maximumSignificantDigits: 5,
    signDisplay: 'never',
  })

export const formatTerm = (value: number) => `${value} ${messages.shortMonth}`

export const convertFormValuesToQueryString = (formValues: ILoanProductsFilterForm, defaultValues: ILoanProductsFilterForm): string => {
  const stringFormValues = Object.keys(formValues).reduce<Record<string, string>>((accum, key) => {
    const item = formValues[key as keyof typeof formValues]

    if (item === undefined || item === defaultValues[key as keyof typeof defaultValues]) {
      return accum
    }

    if (Array.isArray(item) && item.length < 1) {
      return accum
    }

    accum[key] = JSON.stringify(item)

    return accum
  }, {})

  const currentParams = qs.parse(window.location.search.substring(1), { duplicates: 'last' }) as Record<string, string>

  Object.keys(currentParams).forEach(key => {
    if (formKnownValues.has(key)) {
      delete currentParams[key]
    }
  })

  const searchParams = new URLSearchParams({ ...currentParams, ...stringFormValues })

  if ([...searchParams.keys()].length > 0) {
    searchParams.set('noscrolltop', 'true')
  }

  return searchParams.toString()
}

export const convertQueryParamsToFormValues = (queryParams: ILoanProductsFilterQueryParams): Partial<ILoanProductsFilterForm> => {
  return Object.keys(queryParams).reduce((accum, key) => {
    if (!formKnownValues.has(key)) {
      return accum
    }

    accum[key] = JSON.parse(queryParams[key as keyof ILoanProductsFilterQueryParams]!)

    return accum
  }, {} as ILoanProductsFilterForm)
}

export const convertFormValuesToReactQuery = (values: ILoanProductsFilterForm): ViewByOptionsQueryParams => {
  const separator = ','
  const regionCodeAsNumber = isNonNullable(values.regionCode) ? Number(values.regionCode) : undefined

  return {
    regionCode: Number.isNaN(regionCodeAsNumber) ? ALL_REGIONS_CODE : regionCodeAsNumber,
    // incorrectly generated schema
    fundingPurpose: (isNonNullable(values.fundingPurpose) && values.fundingPurpose.length > 0
      ? values.fundingPurpose.join(separator)
      : undefined) as unknown as string[] | undefined,
    loanPeriod: values.loanPeriod,
    // incorrectly generated schema
    options: (isNonNullable(values.options) && values.options.length > 0 ? values.options.join(separator) : undefined) as unknown as
      | ViewByOptionsQueryParamsOptions[]
      | undefined,
    processingSpeed: (isNonNullable(values.processingSpeed) &&
    Object.values(ViewByOptionsQueryParamsProcessingSpeed).includes(values.processingSpeed as ViewByOptionsQueryParamsProcessingSpeed)
      ? values.processingSpeed
      : undefined) as ViewByOptionsQueryParamsProcessingSpeed | undefined,
    requiredAmount: isNonNullable(values.requiredAmount) ? String(values.requiredAmount) : undefined,
  }
}
